import { Link } from 'gatorcomponents';
import React from 'react';

export default {
  productsDetails: {
    modals: {
      createSite: {
        title: () => (
          <>
            {'¿Vamos expandir su marca '}
            <span>creando un nuevo sitio web</span>
            ?
          </>
        ),
        description: {
          0: domain => (
            <>
              {' bilhões de pessoas no mundo estão usando a internet! Não perca tempo e crie um site personalizado para '}
              <span>{`${domain}.`}</span>
            </>
          ),
          1: () => (
            <>
              {'¡5 mil millones de personas em el mundo están usando internet! No pierda tiempo y cree un sitio web personalizado para '}
              <span>Criador de Sites, Wordpress</span>
              {' Usted puede usar el Creador de Sitios web, WordPress u otras herramientas para instalar y personalizar su sitio. :)'}
            </>
          ),
        },
        buttonLabel: 'Crear sitio',
        backButtonLabel: 'No quiero expandir mi marca',
      },
    },
  },
  actions: {
    vpsN8N: {
      connectToSshButtonLabel: 'Conectarse con SSH',
      openN8NButtonLabel: 'Abrir n8n',
    },
  },
  modalN8n: {
    title: 'Cómo acceder a tu VPS con n8n',
    subtitle: 'Sigue los pasos a continuación para acceder a tu VPS con n8n mediante SSH.',
    labels: {
      ip: 'IP',
      port: 'Puerta',
      user: 'Usuario',
      password: 'Contraseña',
    },
    step1Title: 'Abra el SSH en tu computador',
    step1Subtitle: (
      <>
        {'¿Tiene dudas sobre el SSH? '}
        <Link
          href="https://soporte.hostgator.mx/hc/es-419/articles/28443752291091-C%C3%B3mo-acceder-al-SSH"
          target="_blank"
          text="Consulte la documentación"
        />
      </>
    ),
    step2Title: 'Copia las credenciales a continuación para conectarte:',
  },
};
